import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';

@Component({
  selector: 'app-icecommonpages',
  templateUrl: './icecommonpages.component.html',
  styleUrls: ['./icecommonpages.component.css'],
  providers: [utilityService]
})
export class IcecommonpagesComponent implements OnInit {
  pageurl = '';
  router: any;
  pageArray = [];
  constructor(private _router: Router, public utilserv: utilityService) {
    this.router = _router;
    console.log(this.router.url); //  /routename
    this.getPageUrl(this.router.url);
  }
  ngOnInit() {}
  getPageUrl(route) {
    route = route.replace('/', '');
    this.utilserv.restGet(AppSettings.ICEMasterService + '/GetAboutPrivacyURL', true).subscribe(data => {
      this.pageurl = data[route];
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/icecommonpages/icecommonpages.component.ts